import { z } from "zod";
import i18n from "@/i18n";

const t = (key: string) => i18n.t(`partners.admin.validation.${key}`);

export const createPartnerProviderSchema = () =>
  z.object({
    provider: z
      .string()
      .trim()
      .min(1, { message: t("providerRequired") }),
    enabled: z.boolean(),
    baseUrl: z
      .string()
      .trim()
      .min(1, { message: t("baseUrlRequired") }),
    syncIntervalMinutes: z
      .number({
        message: t("syncIntervalInvalid"),
      })
      .int({ message: t("syncIntervalInvalid") })
      .min(0, { message: t("syncIntervalInvalid") }),
    platformFeePercent: z
      .number({
        message: t("platformFeeInvalid"),
      })
      .int({ message: t("platformFeeInvalid") })
      .min(0, { message: t("platformFeeInvalid") }),
    apiKey: z.string().trim().optional(),
    webhookSecret: z.string().trim().optional(),
    description: z.string().trim().optional(),
    categories: z.string().trim().optional(),
    defaultMaxActivitiesEnabled: z.boolean(),
    defaultMaxActivities: z
      .number({ message: t("defaultMaxActivitiesInvalid") })
      .int({ message: t("defaultMaxActivitiesInvalid") })
      .min(1, { message: t("defaultMaxActivitiesInvalid") })
      .max(1000, { message: t("defaultMaxActivitiesInvalid") }),
  });

export type PartnerProviderFormValues = z.input<
  ReturnType<typeof createPartnerProviderSchema>
>;
